<div *ngIf="item" class="tip-item clickable" (click)="openPayment(item.wId, item.paymentId)">
  <div class="d-flex align-items-center overflow-hidden">
    <mat-checkbox class="checkbox"
                  *ngIf="kind === 'Pending' && !(readonly$ | async)" [color]="'primary'"
                  (change)="check($event.checked, item)" (click)="$event.stopPropagation()"
                  [checked]="checked"
    ></mat-checkbox>

    <div class="tip-item-left">
      <div class="name">{{ item.name }}</div>
      <div class="jt">{{ item.jobType ?? 'N/A' }}</div>
    </div>
  </div>

  <div class="tip-item-right">
    <div class="amount"
      [shortNumber]="item.amount | currency"
      #tooltip="matTooltip"
      [matTooltip]="''"
      [shortNumberTooltip]="tooltip"
      [hideTooltipOnScroll]="tooltip"
    ></div>
    <small *ngIf="showUserName$ | async" class="username">{{ userName }}</small>
  </div>
</div>

<div *ngIf="dividerNeed" class="tip-item-divider"></div>
